var _path, _path2, _path3, _path4, _path5, _path6, _circle, _g, _circle2, _g2, _circle3, _g3, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoNoSub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 314,
    height: 100,
    viewBox: "0 0 314 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.84 32H118.48V65.6H109.84V32Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M127.673 32H136.505L145.817 49.04L155.033 32H163.673V65.6H155.033V46.352L148.073 59.12H143.273L136.313 46.352V65.6H127.673V32Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M172.856 32H181.496V65.6H172.856V32Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M198.608 39.104H188.288V32H217.568V39.104H207.248V65.6H198.608V39.104Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.387 32H233.027V65.6H224.387V32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_409_15464)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50 9C72.076 9 90 26.924 90 49C90 71.076 72.076 89 50 89C27.924 89 10 71.076 10 49C10 26.924 27.924 9 50 9Z",
    fill: "url(#paint0_radial_409_15464)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_409_15464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 80,
    height: 80
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49,
    r: 40,
    fill: "url(#paint1_linear_409_15464)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_409_15464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.9286 64C35.5655 63.9257 26.7857 49 10 41.1429V91.1429H90V50.7857C79.6429 60.0714 72.756 64.0761 53.9286 64Z",
    fill: "#FF8238",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_409_15464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 80,
    height: 80
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49,
    r: 40,
    fill: "url(#paint2_linear_409_15464)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_409_15464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.1429 30.4289C38.7796 30.4286 26.4286 50.0717 10 56.5003V91.143H90V46.8572C79.6429 38.286 70 30.4291 57.1429 30.4289Z",
    fill: "#FF8238",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_409_15464",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 9,
    width: 80,
    height: 80
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 49,
    r: 40,
    fill: "url(#paint3_linear_409_15464)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_409_15464)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5 47.9284C34.1368 47.9281 26.4286 62.9284 10 69.3569V91.1426H90V67.571C79.6429 58.9998 65.3571 47.9286 52.5 47.9284Z",
    fill: "#FF8238",
    fillOpacity: 0.6
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50 9C72.076 9 90 26.924 90 49C90 71.076 72.076 89 50 89C27.924 89 10 71.076 10 49C10 26.924 27.924 9 50 9Z",
    fill: "url(#paint4_radial_409_15464)",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_409_15464",
    x: 0,
    y: 0,
    width: 100,
    height: 100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_409_15464"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_409_15464",
    result: "effect2_dropShadow_409_15464"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.14 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_409_15464",
    result: "effect3_dropShadow_409_15464"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_409_15464",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_409_15464",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.16 33.32) scale(68.8246)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EB4B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_409_15464",
    x1: 90,
    y1: 9,
    x2: 10,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_409_15464",
    x1: 90,
    y1: 9,
    x2: 10,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_409_15464",
    x1: 90,
    y1: 9,
    x2: 10,
    y2: 89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_409_15464",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.92 73) scale(47.8355)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EB4B14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D62828"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoNoSub);
export default __webpack_public_path__ + "static/media/logoNoSub.770e62d7686eec4ea61d6146eb94db0d.svg";
export { ForwardRef as ReactComponent };